

import React, { useState } from 'react'
import RegisterService from '../../../services/RegisterService';
import Swal from 'sweetalert2'

const RegisterCLient = (props, state) => {
    const [date, setDate] = useState('')
    const [name, setName] = useState('')
    const [gender, setGender] = useState('')
    const [birthday, setBirthday] = useState('')
    const [email, setEmail] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [height, setHeight] = useState('')
    const [weight, setWeight] = useState('')
    const [size, setSize] = useState('')
    const [goal, setGoal] = useState([])
    const [healthIssues, setHealthIssues] = useState('')
    const [hasAllergies, setHasAllergies] = useState('')
    const [allergiesString, setAllergiesString] = useState('')
    const [foodIntolerance, setFoodIntolerance] = useState('')
    const [constipationIssues, setConstipationIssues] = useState('')
    const [bloodPressureIssues, setBloodPressureIssues] = useState('')
    const [medicines, setMedicines] = useState('')
    const [dayDescription, setDayDescription] = useState('')
    const [breakfastDescription, setBreakfastDescription] = useState('')
    const [lunchDescription, setLunchDescription] = useState('')
    const [dinnerDescription, setDinnerDescription] = useState('')
    const [snackDescription, setSnackDescription] = useState('')
    const [isCookingString, setIsCookingString] = useState('')
    const [dislikesFood, setDislikesFood] = useState('')
    const [likesFood, setLikesFood] = useState('')
    const [numberOfMeals, setNumberOfMeals] = useState('')
    const [waterAmount, setWaterAmount] = useState('')
    const [isSmoker, setIsSmoker] = useState('')
    const [coffee, setCoffee] = useState('')
    const [tea, setTea] = useState('')
    const [softDrinks, setSoftDrinks] = useState('')
    const [alcoholDrinks, setAlcoholDrinks] = useState('')
    const [isEmployed, setIsEmployed] = useState('')
    const [job, setJob] = useState('')
    const [workSchedule, setWorkSchedule] = useState('')
    const [isWorkingNightShifts, setIsWorkingNightShifts] = useState('')
    const [worksOnWeekends, setWorksOnWeekends] = useState('')
    const [hasBreaks, setHasBreaks] = useState('')
    const [canBringFoodToWork, setCanBringFoodToWork] = useState('')
    const [isStudent, setIsStudent] = useState('')
    const [schoolSchedule, setSchoolSchedule] = useState('')
    const [canBringFoodToSchool, setCanBringFoodToSchool] = useState('')
    const [isPhysicallyActive, setIsPhysicallyActive] = useState('')
    const [physicalActivity, setPhysicalActivity] = useState('')
    const [physicalActivityIntensity, setPhysicalActivityIntensity] = useState('')
    const [physicalActivityAmount, setPhysicalActivityAmount] = useState('')
    const [physicalActivityDays, setPhysicalActivityDays] = useState('')
    const [physicalActivityTime, setPhysicalActivityTime] = useState('')
    const [isPregnant, setIsPregnant] = useState('')
    const [pregnancyMonth, setPregnancyMonth] = useState('')
    const [pregnancyWeightStart, setPregnancyWeightStart] = useState('')
    const [pregnancyWeightGain, setPregnancyWeightGain] = useState('')
    const [breastFeeding, setBreastFeeding] = useState('')
    const [note, setNote] = useState('')
    const [isDisabled, setIsDisabled] = useState(false);

    const handleFormSubmit = e => {
        e.preventDefault();
        Swal.fire({
            title: 'Da li ste popunili sva zeljena polja?',
            showCancelButton: true,
            confirmButtonText: 'Da',
            cancelButtonText: `Ne`,
        }).then((result) => {
            if (result.isConfirmed) {
                let client = getClientObject()
                client.needsAPlan = true
                if (client.goal instanceof Array) {
                    let goal = ""
                    client.goal.forEach(g => goal += g + ", ")
                    client.goal = goal
                }

                RegisterService.postClient(client).then(() => {
                    Swal.fire("Hvala na izdvojenom vremenu za popunjavanje ovog upitnika.")
                    setIsDisabled(true);
                })
            }
        })

    }

    const setIfChecked = (e, array, callback) => {
        let index = array.indexOf(e.target.value)
        if (e.target.checked) {
            if (index === -1)
                array.push(e.target.value)
        } else {
            array.splice(index, 1)
        }
        callback(array)
    }

    const getClientObject = () => {
        return {
            "date": new Date(),
            "name": name,
            "gender": gender,
            "birthday": birthday,
            "email": email,
            "phoneNumber": phoneNumber,
            "height": height,
            "weight": weight,
            "size": size,
            "goal": goal,
            "healthIssues": healthIssues,
            "hasAllergies": hasAllergies,
            "allergiesString": allergiesString,
            "foodIntolerance": foodIntolerance,
            "constipationIssues": constipationIssues,
            "bloodPressureIssues": bloodPressureIssues,
            "medicines": medicines,
            "dayDescription": dayDescription,
            "breakfastDescription": breakfastDescription,
            "lunchDescription": lunchDescription,
            "dinnerDescription": dinnerDescription,
            "snackDescription": snackDescription,
            "isCookingString": isCookingString,
            "dislikesFood": dislikesFood,
            "likesFood": likesFood,
            "numberOfMeals": numberOfMeals,
            "waterAmount": waterAmount,
            "isSmoker": isSmoker,
            "coffee": coffee,
            "tea": tea,
            "softDrinks": softDrinks,
            "alcoholDrinks": alcoholDrinks,
            "isEmployed": isEmployed,
            "job": job,
            "workSchedule": workSchedule,
            "isWorkingNightShifts": isWorkingNightShifts,
            "worksOnWeekends": worksOnWeekends,
            "hasBreaks": hasBreaks,
            "canBringFoodToWork": canBringFoodToWork,
            "isStudent": isStudent,
            "schoolSchedule": schoolSchedule,
            "canBringFoodToSchool": canBringFoodToSchool,
            "isPhysicallyActive": isPhysicallyActive,
            "physicalActivity": physicalActivity,
            "physicalActivityIntensity": physicalActivityIntensity,
            "physicalActivityAmount": physicalActivityAmount,
            "physicalActivityDays": physicalActivityDays,
            "physicalActivityTime": physicalActivityTime,
            "isPregnant": isPregnant,
            "pregnancyMonth": pregnancyMonth,
            "pregnancyWeightStart": pregnancyWeightStart,
            "pregnancyWeightGain": pregnancyWeightGain,
            "breastFeeding": breastFeeding,
            "note": note,
        }
    }


    return (
        <div className="flex justify-center items-center w-full h-full min-w-screen min-h-screen">
            <div className="relative w-[500px] max-h-[calc(100vh-50px)] md:max-w-[400px] lg:max-w-[600px]  text-left justify-center px-5 py-7">
                <form>
                    <div className="input-group">
                        <h2>Upitnik za online plan ishrane</h2>
                        <p>Ovaj upitnik je informativnog karaktera,
                            i služi za bolje upoznavanje sa Vašim navikama i obavezama,
                            kako bih mogla da Vam što bolje prilagodim ishranu.
                            Nisu sva pitanja obavezna,
                            ako Vam neko pitanje nije jasno ili ne želite da date odgovor, preskočite ga.
                            Molim Vas da na pitanja odgovorite iskreno, i ako je moguće na sva pitanja,
                            jer je to u Vašem i mom zajedničkom intetresu.</p><br />
                    </div>


                    <div className="input-group">
                        <strong htmlFor="216857310">Ime i prezime</strong>
                        <div className="form-group">
                            <input id="1291924601" type="text" value={name} onChange={(e) => setName(e.target.value)} className="input-field" required />
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="518254141">Pol:</strong>
                        <div className="form-group">
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={gender === "Muški"} className='mx-3' onChange={(e) => setGender(e.target.value)} value="Muški" required />
                                    Muški
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={gender === "Ženski"} className='mx-3' onChange={(e) => setGender(e.target.value)} value="Ženski" required />
                                    Ženski
                                </label>
                            </div>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="2085718577">Datum rodjenja:</strong>
                        <div className="form-group">
                            <input id="1809518826" type="text" value={birthday} onChange={(e) => setBirthday(e.target.value)} className="input-field" required />
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="786039979">Kontakt e-mail:</strong>
                        <div className="form-group">
                            <input id="368812813" type="text" value={email} onChange={(e) => setEmail(e.target.value)} className="input-field" required />
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="78654766">Broj telefona:</strong>
                        <div className="form-group">
                            <input id="1916334279" type="text" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} className="input-field" />
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="222965332">Visina u cm:</strong>
                        <div className="form-group">
                            <input id="1315844241" type="text" value={height} onChange={(e) => setHeight(e.target.value)} className="input-field" required />
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="1442420007">Telesna težina u kg (izmerena jutros):</strong>
                        <div className="form-group">
                            <input id="988817910" type="text" value={weight} onChange={(e) => setWeight(e.target.value)} className="input-field" required />
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="1597032160">Upišite obime:</strong>
                        <div className="form-group">
                            <p className="help-block">Obim grudi, nadlaktice, struka, kukova i butina.</p>
                            <textarea id="912242983" className="input-field" value={size} onChange={(e) => setSize(e.target.value)} ></textarea>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="1538740465">Koji je Vaš cilj?</strong>
                        <div className="form-group">
                            <p className="help-block">Moguće je obeležiti više polja.</p>
                            <div className="checkbox">
                                <label>
                                    <input type="checkbox" className='mx-3' onChange={(e) => setIfChecked(e, goal, setGoal)} value="Redukcija masnog tkiva" required />
                                    Redukcija masnog tkiva
                                </label>
                            </div>
                            <div className="checkbox">
                                <label>
                                    <input type="checkbox" className='mx-3' onChange={(e) => setIfChecked(e, goal, setGoal)} value="Povećanje telesne mase" required />
                                    Povećanje telesne mase
                                </label>
                            </div>
                            <div className="checkbox">
                                <label>
                                    <input type="checkbox" className='mx-3' onChange={(e) => setIfChecked(e, goal, setGoal)} value="Želim da se hranim zdravije" required />
                                    Želim da se hranim zdravije
                                </label>
                            </div>
                            <div className="checkbox">
                                <label>
                                    <input type="checkbox" className='mx-3' onChange={(e) => setIfChecked(e, goal, setGoal)} value="Želim da prilagodim ishranu svom trenažnom procesu" required />
                                    Želim da prilagodim ishranu svom trenažnom procesu
                                </label>
                            </div>
                            <div className="checkbox">
                                <label>
                                    <input type="checkbox" className='mx-3' onChange={(e) => setIfChecked(e, goal, setGoal)} value="Ishrana trudnica" required />
                                    Ishrana trudnica
                                </label>
                            </div>
                            <div className="checkbox">
                                <label>
                                    <input type="checkbox" className='mx-3' onChange={(e) => setIfChecked(e, goal, setGoal)} value="Ishrana dojilja" required />
                                    Ishrana dojilja
                                </label>
                            </div>
                            <div className="checkbox">
                                <label>
                                    <input type="checkbox" className='mx-3' onChange={(e) => setIfChecked(e, goal, setGoal)} value="Dijetoterapija (dijabetes, giht, gastritis, kandida, hipertenzija, poremećaj rada štitne žlezde i druga oboljenja)" required />
                                    Dijetoterapija (dijabetes, giht, gastritis, kandida, hipertenzija, poremećaj rada štitne žlezde i druga oboljenja)
                                </label>
                            </div>
                            <div className="checkbox">
                                <label>
                                    <input type="checkbox" className='mx-3' onChange={(e) => setIfChecked(e, goal, setGoal)} value="Vegeterijanska ishrana" required />
                                    Vegeterijanska ishrana
                                </label>
                            </div>
                            <div className="checkbox">
                                <label>
                                    <input type="checkbox" className='mx-3' value="__other_option__" required />
                                </label>
                                <input type="text" value={goal} onChange={(e) => setGoal(e.target.value)} placeholder="neki drugi cilj" />
                            </div>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="9749428">Da li imate nekih zdravstvenih problema, ili imate uspostavljenu neku dijagnozu?</strong>
                        <div className="form-group">
                            <p className="help-block">Uključujući visok ili nizak krvni pritisak, dijabetes, insulinsku rezistenciju, holesterol, kandidu, bolest bubrega, probleme sa štitnom žlezdom, čir, ili bilo koje drugo zdravstveno stanje.</p>
                            <textarea id="2126986241" value={healthIssues} onChange={(e) => setHealthIssues(e.target.value)} className="input-field"  ></textarea>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="1294144371">Da li imate neke alergije na hranu?</strong>
                        <div className="form-group">
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={hasAllergies === "Da"} className='mx-3' onChange={(e) => setHasAllergies(e.target.value)} value="Da" required />
                                    Da
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={hasAllergies === "Ne"} className='mx-3' onChange={(e) => setHasAllergies(e.target.value)} value="Ne" required />
                                    Ne
                                </label>
                            </div>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="1763343489">Ako imate, koje?</strong>
                        <div className="form-group">
                            <input id="1288194705" type="text" value={allergiesString} onChange={(e) => setAllergiesString(e.target.value)} className="input-field" />
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="1441188471">Da li ste intolerantni na neku hranu?</strong>
                        <div className="form-group">
                            <p className="help-block">Da li Vam nešto od hrane smeta, nadima Vas, ili izaziva neku drugu neprijatnost? (laktoza, testo, pečurke...)</p>
                            <textarea id="56788549" className="input-field" value={foodIntolerance} onChange={(e) => setFoodIntolerance(e.target.value)} ></textarea>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="846005446">Da li imate problema sa opstipacijom (zatvorom)?</strong>
                        <div className="form-group">
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={constipationIssues === "Ne, svaki dan idem u wc"} className='mx-3' onChange={(e) => setConstipationIssues(e.target.value)} value="Ne, svaki dan idem u wc" />
                                    Ne, svaki dan idem u wc
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={constipationIssues === "Idem u wc 3-5 puta nedeljno"} className='mx-3' onChange={(e) => setConstipationIssues(e.target.value)} value="Idem u wc 3-5 puta nedeljno" />
                                    Idem u wc 3-5 puta nedeljno
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={constipationIssues === "Idem u wc jednom nedeljno ili redje"} className='mx-3' onChange={(e) => setConstipationIssues(e.target.value)} value="Idem u wc jednom nedeljno ili redje" />
                                    Idem u wc jednom nedeljno ili redje
                                </label>
                            </div>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="1654064100">Da li imate problema sa krvnim pritiskom?</strong>
                        <div className="form-group">
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={bloodPressureIssues === "Da, povišen krvni pritisak"} className='mx-3' onChange={(e) => setBloodPressureIssues(e.target.value)} value="Da, povišen krvni pritisak" />
                                    Da, povišen krvni pritisak
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={bloodPressureIssues === "Da, snižen krvni pritisak"} className='mx-3' onChange={(e) => setBloodPressureIssues(e.target.value)} value="Da, snižen krvni pritisak" />
                                    Da, snižen krvni pritisak
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={bloodPressureIssues === "Ne"} className='mx-3' onChange={(e) => setBloodPressureIssues(e.target.value)} value="Ne" />
                                    Ne
                                </label>
                            </div>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="1141624379">Da li koristite neke lekove ili suplemente?</strong>
                        <div className="form-group">
                            <textarea id="669091645" className="input-field" value={medicines} onChange={(e) => setMedicines(e.target.value)}  ></textarea>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="520003997">Opišite mi detaljno jedan Vaš prosečan dan.</strong>
                        <div className="form-group">
                            <p className="help-block">Kad ustajete? Kad idete na spavanje? Kako provodite dan? Da li većinu vremena sedite ili stojite? U koje vreme su obroci? Da li se vikend razlikuje od radnog dana?</p>
                            <textarea id="2115155149" className="input-field" value={dayDescription} onChange={(e) => setDayDescription(e.target.value)}  ></textarea>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="1446555739">Šta najčešće doručkujete? U koje vreme je doručak radnim danima, a kad vikendom?</strong>
                        <div className="form-group">
                            <textarea id="1711631685" className="input-field" value={breakfastDescription} onChange={(e) => setBreakfastDescription(e.target.value)}  ></textarea>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="2067757711">Šta najčešće ručate? U koje vreme je ručak radnim danima, a kad vikendom?</strong>
                        <div className="form-group">
                            <textarea id="2079404755" className="input-field" value={lunchDescription} onChange={(e) => setLunchDescription(e.target.value)}  ></textarea>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="1653874920">Šta najčešće večerate? U koje vreme je večera radnim danima, a kad vikendom?</strong>
                        <div className="form-group">
                            <textarea id="1297156411" className="input-field" value={dinnerDescription} onChange={(e) => setDinnerDescription(e.target.value)}  ></textarea>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="2002534504">Šta pojedete između obroka? </strong>
                        <div className="form-group">
                            <p className="help-block">Da li jedete slatkiše, voće, grickalice, orašaste plodove ili nešto drugo?</p>
                            <textarea id="1509496439" className="input-field" value={snackDescription} onChange={(e) => setSnackDescription(e.target.value)}  ></textarea>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="728735244">Da li kuvate, i koliko često?</strong>
                        <div className="form-group">
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={isCookingString === "Da, svaki dan"} className='mx-3' onChange={(e) => setIsCookingString(e.target.value)} value="Da, svaki dan" />
                                    Da, svaki dan
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={isCookingString === "Da, svaki drugi dan"} className='mx-3' onChange={(e) => setIsCookingString(e.target.value)} value="Da, svaki drugi dan" />
                                    Da, svaki drugi dan
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={isCookingString === "Ne"} className='mx-3' onChange={(e) => setIsCookingString(e.target.value)} value="Ne" />
                                    Ne
                                </label>
                            </div>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="323479196">Koju hranu NE VOLITE da jedete?</strong>
                        <div className="form-group">
                            <p className="help-block">(jogurt, mleko, kiselo mleko, kefir, feta sir, mladi sir, ella sir, tikvice, pečurke, paprika, patlidžan, spanać, blitva, karfiol, brokoli, grašak, boranija, sladak kupus, pasulja, šargrepa, salate, piletina, junetina, ćuretina, pršut, pečenica, pileća prsa, ćureća prsa, sveža riba, tunjevina, sardina, maslinovo ulje, humus, masline, badem, lešnik, orah, laneno seme, čia seme, voće, integralni hleb, pirinač, palenta, proja, krompir, testenine, ovsene pahuljice, proso...gulaš, paprikaš, musake, pilav, rižoto...)</p>
                            <textarea id="681441271" className="input-field" value={dislikesFood} onChange={(e) => setDislikesFood(e.target.value)}  ></textarea>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="510686958">Da li postoji nešto od hrane što mnogo volite i bez čega mislite da ne možete?</strong>
                        <div className="form-group">
                            <p className="help-block">(Slatkiši, sokovi, hleb...)</p>
                            <textarea id="1256755572" className="input-field" value={likesFood} onChange={(e) => setLikesFood(e.target.value)}   ></textarea>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="487424976">Koliko imate obroka u toku dana (uključujući užine)?</strong>
                        <div className="form-group">
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={numberOfMeals === "1-2"} className='mx-3' onChange={(e) => setNumberOfMeals(e.target.value)} value="1-2" />
                                    1-2
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={numberOfMeals === "3-4"} className='mx-3' onChange={(e) => setNumberOfMeals(e.target.value)} value="3-4" />
                                    3-4
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={numberOfMeals === "5 i više"} className='mx-3' onChange={(e) => setNumberOfMeals(e.target.value)} value="5 i više" />
                                    5 i više
                                </label>
                            </div>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="924182810">Koliko vode popijete u toku dana?</strong>
                        <div className="form-group">
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={waterAmount === "Do pola litre (2 čaše)"} className='mx-3' onChange={(e) => setWaterAmount(e.target.value)} value="Do pola litre (2 čaše)" />
                                    Do pola litre (2 čaše)
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={waterAmount === "Litar (oko 4 čaše)"} className='mx-3' onChange={(e) => setWaterAmount(e.target.value)} value="Litar (oko 4 čaše)" />
                                    Litar (oko 4 čaše)
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={waterAmount === "Litar i po (oko 6 čaša)"} className='mx-3' onChange={(e) => setWaterAmount(e.target.value)} value="Litar i po (oko 6 čaša)" />
                                    Litar i po (oko 6 čaša)
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={waterAmount === "Dve litre (oko 8 čaša)"} className='mx-3' onChange={(e) => setWaterAmount(e.target.value)} value="Dve litre (oko 8 čaša)" />
                                    Dve litre (oko 8 čaša)
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={waterAmount === "Preko dve litre vode"} className='mx-3' onChange={(e) => setWaterAmount(e.target.value)} value="Preko dve litre vode" />
                                    Preko dve litre vode
                                </label>
                            </div>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="2141558691">Da li ste pušač?</strong>
                        <div className="form-group">
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={isSmoker === "Da"} className='mx-3' onChange={(e) => setIsSmoker(e.target.value)} value="Da" />
                                    Da
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={isSmoker === "Ne"} className='mx-3' onChange={(e) => setIsSmoker(e.target.value)} value="Ne" />
                                    Ne
                                </label>
                            </div>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="769189646">Da li pijete kafu?</strong>
                        <div className="form-group">
                            <p className="help-block">Koju kafu (domaća, nes, espreso), da li dodajete šećer i mleko i koliko šoljica dnevno popijete?</p>
                            <input id="147487162" type="text" value={coffee} onChange={(e) => setCoffee(e.target.value)} className="input-field" />
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="2002447148">Da li pijete čaj?</strong>
                        <div className="form-group">
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={tea === "Da"} className='mx-3' onChange={(e) => setTea(e.target.value)} value="Da" />
                                    Da
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={tea === "Ne"} className='mx-3' onChange={(e) => setTea(e.target.value)} value="Ne" />
                                    Ne
                                </label>
                            </div>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="1002233482">Da li pijete sokove?</strong>
                        <div className="form-group">
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={softDrinks === "Da, često (svaki dan)"} className='mx-3' onChange={(e) => setSoftDrinks(e.target.value)} value="Da, često (svaki dan)" />
                                    Da, često (svaki dan)
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={softDrinks === "Da, ponekad (2x nedeljno ili ređe)"} className='mx-3' onChange={(e) => setSoftDrinks(e.target.value)} value="Da, ponekad (2x nedeljno ili ređe)" />
                                    Da, ponekad (2x nedeljno ili ređe)
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={softDrinks === "Ne"} className='mx-3' onChange={(e) => setSoftDrinks(e.target.value)} value="Ne" />
                                    Ne
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="input-group">
                        <strong htmlFor="1002233482">Da li konzumirate alkohol?</strong>
                        <div className="form-group">
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={alcoholDrinks === "Da"} className='mx-3' onChange={(e) => setAlcoholDrinks(e.target.value)} value="Da" />
                                    Da, često (svaki dan)
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={alcoholDrinks === "Ne"} className='mx-3' onChange={(e) => setAlcoholDrinks(e.target.value)} value="Ne" />
                                    Ne
                                </label>
                            </div>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="641335667">Posao</strong>
                        <div className="form-group">
                            <p className="help-block">Ako nemate stalno zaposlenje, obeležite &quot;ne&quot; i preskočite ovaj odeljak.</p>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="167262145">Da li ste zaposleni?</strong>
                        <div className="form-group">
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={isEmployed === "Da"} className='mx-3' onChange={(e) => setIsEmployed(e.target.value)} value="Da" />
                                    Da
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={isEmployed === "Ne"} className='mx-3' onChange={(e) => setIsEmployed(e.target.value)} value="Ne" />
                                    Ne
                                </label>
                            </div>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="376719784">Ako jeste, čime se bavite?</strong>
                        <div className="form-group">
                            <input id="348010274" type="text" value={job} onChange={(e) => setJob(e.target.value)} className="input-field" />
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="2011045413">Koje Vam je radno vreme?</strong>
                        <div className="form-group">
                            <input id="1959286056" type="text" value={workSchedule} onChange={(e) => setWorkSchedule(e.target.value)} className="input-field" />
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="1806352685">Da li radite treće smene?</strong>
                        <div className="form-group">
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={isWorkingNightShifts === "Da"} className='mx-3' onChange={(e) => setIsWorkingNightShifts(e.target.value)} value="Da" />
                                    Da
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={isWorkingNightShifts === "Ne"} className='mx-3' onChange={(e) => setIsWorkingNightShifts(e.target.value)} value="Ne" />
                                    Ne
                                </label>
                            </div>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="2002071226">Da li radite vikendom?</strong>
                        <div className="form-group">
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={worksOnWeekends === "Da"} className='mx-3' onChange={(e) => setWorksOnWeekends(e.target.value)} value="Da" />
                                    Da
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={worksOnWeekends === "Ne"} className='mx-3' onChange={(e) => setWorksOnWeekends(e.target.value)} value="Ne" />
                                    Ne
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={worksOnWeekends === "Samo subotom"} className='mx-3' onChange={(e) => setWorksOnWeekends(e.target.value)} value="Samo subotom" />
                                    Samo subotom
                                </label>
                            </div>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="1693078867">Da li imate određeno vreme za pauzu ili možete da napravite pauzu kada vama odgovara?</strong>
                        <div className="form-group">
                            <input id="267206317" type="text" className="input-field" value={hasBreaks} onChange={(e) => setHasBreaks(e.target.value)} />
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="15947613">Da li možete da ponesete hranu na posao?</strong>
                        <div className="form-group">
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={canBringFoodToWork === "Da"} className='mx-3' onChange={(e) => setCanBringFoodToWork(e.target.value)} value="Da" />
                                    Da
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={canBringFoodToWork === "Ne"} className='mx-3' onChange={(e) => setCanBringFoodToWork(e.target.value)} value="Ne" />
                                    Ne
                                </label>
                            </div>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="1527756199">Škola/fakultet</strong>
                        <div className="form-group">
                            <p className="help-block">Ako niste učenik/student, obeležite &quot;NE&quot; i preskočite ovaj odeljak.</p>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="67588517">Da li ste redovan učenik/ca ili student?</strong>
                        <div className="form-group">
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={isStudent === "Da"} className='mx-3' onChange={(e) => setIsStudent(e.target.value)} value="Da" />
                                    Da
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={isStudent === "Ne"} className='mx-3' onChange={(e) => setIsStudent(e.target.value)} value="Ne" />
                                    Ne
                                </label>
                            </div>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="2099686247">Kada Vam počinju i kada se završavaju časovi/predavanja?</strong>
                        <div className="form-group">
                            <textarea id="1109620131" className="input-field" value={schoolSchedule} onChange={(e) => setSchoolSchedule(e.target.value)}  ></textarea>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="1563992807">Da li bi Vam bio problem da nosite ručak ili užinu u školu/na fakultet?</strong>
                        <div className="form-group">
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={canBringFoodToSchool === "Da"} className='mx-3' onChange={(e) => setCanBringFoodToSchool(e.target.value)} value="Da" />
                                    Da
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={canBringFoodToSchool === "Ne"} className='mx-3' onChange={(e) => setCanBringFoodToSchool(e.target.value)} value="Ne" />
                                    Ne
                                </label>
                            </div>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="1219103706">Fizička aktivnost</strong>
                        <div className="form-group">
                            <p className="help-block">Pod ovim se podrazumeva rekreativno ili profesionalno bavljenje nekim sportom ili aktivnošću. Ukoliko niste fizički aktivni, obeležite &quot;ne&quot; i preskočite ovaj odeljak)</p>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="1641964166">Da li ste fizički aktivni?</strong>
                        <div className="form-group">
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={isPhysicallyActive === "Da"} className='mx-3' onChange={(e) => setIsPhysicallyActive(e.target.value)} value="Da" />
                                    Da
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={isPhysicallyActive === "Ne"} className='mx-3' onChange={(e) => setIsPhysicallyActive(e.target.value)} value="Ne" />
                                    Ne
                                </label>
                            </div>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="461895194">Kojom fizičkom aktivnošću se bavite?</strong>
                        <div className="form-group">
                            <p className="help-block">(teretana, trčanje, šetnje, bicikl, pilates, aerobik ili nešto drugo..) </p>
                            <input id="1396930713" type="text" value={physicalActivity} onChange={(e) => setPhysicalActivity(e.target.value)} className="input-field" />
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="1686231215">Koji je intenzitet vežbanja? </strong>
                        <div className="form-group">
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={physicalActivityIntensity === "Laganiji tip treninga"} className='mx-3' onChange={(e) => setPhysicalActivityIntensity(e.target.value)} value="Laganiji tip treninga" />
                                    Laganiji tip treninga
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={physicalActivityIntensity === "Srednji tip treninga"} className='mx-3' onChange={(e) => setPhysicalActivityIntensity(e.target.value)} value="Srednji tip treninga" />
                                    Srednji tip treninga
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={physicalActivityIntensity === "Teži tip treninga"} className='mx-3' onChange={(e) => setPhysicalActivityIntensity(e.target.value)} value="Teži tip treninga" />
                                    Teži tip treninga
                                </label>
                            </div>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="20040024">Koliko redovno upažnjavate fizičku aktivnost?</strong>
                        <div className="form-group">
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={physicalActivityAmount === "1-3 puta nedeljno"} className='mx-3' onChange={(e) => setPhysicalActivityAmount(e.target.value)} value="1-3 puta nedeljno" />
                                    1-3 puta nedeljno
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={physicalActivityAmount === "3-5 puta nedeljno"} className='mx-3' onChange={(e) => setPhysicalActivityAmount(e.target.value)} value="3-5 puta nedeljno" />
                                    3-5 puta nedeljno
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={physicalActivityAmount === "6 ili više  puta nedeljno"} className='mx-3' onChange={(e) => setPhysicalActivityAmount(e.target.value)} value="6 ili više  puta nedeljno" />
                                    6 ili više  puta nedeljno
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="input-group">
                        <strong htmlFor="1319090577">Kojim danima imate treninge?</strong>
                        <div className="form-group">
                            <input id="1155633437" type="text" value={physicalActivityDays} onChange={(e) => setPhysicalActivityDays(e.target.value)} className="input-field" />
                        </div>
                    </div>

                    <div className="input-group">
                        <strong htmlFor="1730604408">U koje vreme su treninzi?</strong>
                        <div className="form-group">
                            <input id="1925579843" type="text" value={physicalActivityTime} onChange={(e) => setPhysicalActivityTime(e.target.value)} className="input-field" />
                        </div>
                    </div>

                    <div className="input-group">
                        <strong htmlFor="2134437817">Trudnice/dojilje</strong>
                        <div className="form-group">
                            <p className="help-block">Ako niste trudnica/dojilja, obeležite &quot;NE&quot; i preskočite ovaj odeljak.</p>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="158716350">Da li ste trudnica ili dojilja?</strong>
                        <div className="form-group">
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={isPregnant === "Da, trudnica"} className='mx-3' onChange={(e) => setIsPregnant(e.target.value)} value="Da, trudnica" />
                                    Da, trudnica
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={isPregnant === "Da, dojilja"} className='mx-3' onChange={(e) => setIsPregnant(e.target.value)} value="Da, dojilja" />
                                    Da, dojilja
                                </label>
                            </div>
                            <div className="radio">
                                <label>
                                    <input type="radio" checked={isPregnant === "Ne"} className='mx-3' onChange={(e) => setIsPregnant(e.target.value)} value="Ne" />
                                    Ne
                                </label>
                            </div>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="1911420862">Ako ste trudnica, koji ste mesec trudnoće?</strong>
                        <div className="form-group">
                            <input id="1516918491" type="text" value={pregnancyMonth} onChange={(e) => setPregnancyMonth(e.target.value)} className="input-field" />
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="964606404">Sa koliko kilograma ste ostali trudni?</strong>
                        <div className="form-group">
                            <input id="322248446" type="text" className="input-field" value={pregnancyWeightStart} onChange={(e) => setPregnancyWeightStart(e.target.value)} />
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="997198174">Koliko ste kilograma dobili u trudnoći?</strong>
                        <div className="form-group">
                            <input id="802553043" type="text" className="input-field" value={pregnancyWeightGain} onChange={(e) => setPregnancyWeightGain(e.target.value)} />
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="755382538">Ako ste dojilja, koliko beba ima meseci i koliko često dojite?</strong>
                        <div className="form-group">
                            <textarea id="58967588" className="input-field" value={breastFeeding} onChange={(e) => setBreastFeeding(e.target.value)} ></textarea>
                        </div>
                    </div>


                    <div className="input-group">
                        <strong htmlFor="634609421">NAPOMENA</strong>
                        <div className="form-group">
                            <p className="help-block">Sve što mislite da nije obuhvaćeno upitnikom, molim Vas da napišete ovde.</p>
                            <textarea id="2042743202" className="input-field" value={note} onChange={(e) => setNote(e.target.value)} ></textarea>
                        </div>
                    </div>

                    <input type="hidden" name="fvv" value="1" />
                    <input type="hidden" name="fbzx" value="-8610204054850280029" />
                    <input type="hidden" name="pageHistory" value="0" />
                    <button type="submit" disabled style={{ display: "none" }} aria-hidden="true"></button>

                    <button type="submit" className="button without-icon bg-secondaryGradient mx-auto" disabled={isDisabled} onClick={e => handleFormSubmit(e)}>
                        Prosledi
                    </button>
                    <br />
                </form>
            </div>
        </div>
    )
}

export default RegisterCLient
